"use client";

import { Carousel } from "@/components/common";
import { getStrapiMedia } from "@repo/lib/utils";
import { MotionContainer } from "@repo/ui";
import Image from "next/image";
const Testimonials = ({
  data,
  locale
}) => {
  if (data?.Testimonial?.length === 0) return null;
  return <MotionContainer data-sentry-element="MotionContainer" data-sentry-component="Testimonials" data-sentry-source-file="Testimonials.jsx">
      <section className="bg-supportiveDarkYellow mx-auto py-6 md:px-4 md:py-24">
        <Carousel items={data?.Testimonial || []} locale={locale} slideWidth="100%" renderItem={item => <div className="mx-auto flex max-w-[870px] flex-col items-center justify-center gap-3 px-4">
              {item?.picture?.url && <Image src={getStrapiMedia(item?.picture?.url)} alt={item?.authorName} width={item?.picture?.width} height={item?.picture?.height} />}
              {item?.paragraph && <p className="font-heading rtl:font-arabic text-center text-sm font-medium md:text-xl">
                  {item?.paragraph}
                </p>}
              <div className="text-center">
                {item?.authorName && <p className="text-sm font-medium md:text-base">
                    {item?.authorName}
                  </p>}
                {item?.authorTitle && <p className="text-supportiveBlack text-xs font-normal md:text-sm">
                    {item?.authorTitle}
                  </p>}
              </div>
            </div>} data-sentry-element="Carousel" data-sentry-source-file="Testimonials.jsx" />
      </section>
    </MotionContainer>;
};
export default Testimonials;